<script>
  export let starCount;
  export let fillRate;
  function calculateWidth(index) {
    let calc = fillRate - (index);
    if (calc >= 1) {
      return 100;
    } else if(calc > 0 && calc < 1) {
      return 100 * calc;
    } else {
      return 0;
    }

  }
</script>
<ul>
  {#each Array(starCount) as _, index (index)}
    <li class="position-relative d-inline-block">
      <i class="fas fa-star align-top"></i>
      {#if calculateWidth(index)}
        <i class="fas fa-star position-absolute top-0 start-0 overflow-hidden text-orange" style={`width: ${calculateWidth(index)}%;`}></i>
      {/if}
    </li>
	{/each}
</ul>
